export const getGroupPictureThumbnail = (
  groupId: string | undefined,
  version?: number | string
): string | undefined => {
  const STORAGE_BASE_URL = "https://firebasestorage.googleapis.com/v0/b";
  const GROUP_PICTURES_FOLDER = "group-pictures";
  const THUMBNAIL_FILENAME = `original_200x200.webp`;
  const BUCKET = process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET;

  const thumbnailUrl = `${STORAGE_BASE_URL}/${BUCKET}/o/${encodeURIComponent(
    `${GROUP_PICTURES_FOLDER}/${groupId}/thumbs/${THUMBNAIL_FILENAME}`
  )}?alt=media${version ? `&v=${version}` : ""}`;

  return thumbnailUrl;
};
